import Api from "./Api";

type KpiKey = TestRequestRaw.Schemas.KpiKey;
type KpiValue = TestRequestRaw.Schemas.KpiValue;

class KpiApi {
  constructor(private api: Api) {}

  public fetchKpiDashboard(): Promise<Record<KpiKey, KpiValue>> {
    return this.api.get("test-request/v2/kpi/dashboard").then((response) => response.data);
  }
}

export default KpiApi;
